import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'


export default {

    async [actionTypes.SALA_ESPERA.ADICIONAR_PACIENTE](context, pacienteId) {
        const {data} = await api.salaEspera.adicionarPaciente(pacienteId)
        return data
    },

    async [actionTypes.SALA_ESPERA.BUSCAR_DADOS]() {
        const {data} = await api.salaEspera.buscarDados()
        return data
    },

    async [actionTypes.SALA_ESPERA.REMOVER_SALA_ESPERA](context, salaEsperaId) {
        await api.salaEspera.removerSalaEspera(salaEsperaId)
    },

}